import { LitElement, html, svg } from 'lit';

export class IconTriangle16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" fill="none" viewBox="0 0 17 16"><title>Varseltrekant</title><path stroke="currentColor" stroke-width="1.5" d="M.904 13.094 6.483 1.625c.54-1.11 2.115-1.129 2.681-.032l5.923 11.469a1.5 1.5 0 0 1-1.332 2.188H2.253a1.5 1.5 0 0 1-1.35-2.156Z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.037 5.393V9M8.008 12v.5"></path></svg>`; }
}
if (!customElements.get('f-icon-triangle16', IconTriangle16)) {
  customElements.define('f-icon-triangle16', IconTriangle16);
}